module.exports = __webpack_public_path__ + "img/keypad-blue.733a25ea.svg";